import request from '@/utils/request'

const _Prefix = "/houseResourceSet"

// 查询房源信息列表
export function houseResourceList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询房源信息详细
export function getHouseResource(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增房源信息
export function addHouseResource(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改房源信息
export function updateHouseResource(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除房源信息
export function delHouseResource(ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}

// 删除房源自定义标签信息
export function delHouseResTag(ids) {
    return request({
        url: '/houseInfo/delete/tag/' + ids,
        method: 'delete'
    })
}